import { useQuery } from "@tanstack/react-query"
import { apiFetch } from "@/hooks/apiFetch"
import { toast } from "sonner"

export const useCustomQuery = (
  queryName,
  url,
  options = {} // Specify the correct generic type here
) => {
  const query = useQuery({
    queryKey: queryName,
    queryFn: () => apiFetch(url), // This should now match R
    ...options,
  })

  if (query.isError) {
    toast.error(query.error.message)
  }
  return query
}
